import React, { useState, useContext } from "react";
import {
  Paper,
  Container,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";

import { DataContext } from "../../../../context/DataContext";
import { getToken } from "../../../../api/Account";

import { simpleMessage } from "../../../../helpers/Helpers";
import { addAbonoPrestamoAsync } from "../../../../api/Employees";

const AddAbono = ({ saldo, id, setShowModal, reload, setReload }) => {
  const [monto, setMonto] = useState("");

  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  const token = getToken();

  const saveChanges = async () => {
    if (monto.length === 0) {
      simpleMessage("Ingrese una descripcion", "error");
      return;
    }

    const data = {
      prestamoId: id,
      monto,
    };

    setIsLoading(true);
    const result = await addAbonoPrestamoAsync(token, data);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }
    setIsLoading(false);
    simpleMessage("Abono Agregado...!", "success");

    setReload(!reload);
    setShowModal(false);
  };

  //Devuelve un entero positivo
  const funtionSetMonto = (value) => {
    if (/^\d*\.?\d*$/.test(value.toString()) || value === "") {
      if (value > saldo) {
        simpleMessage("No puede abonar mas de lo que debe", "error");
        return;
      }
      setMonto(value);
      return;
    }
  };
  return (
    <div>
      <Container style={{ width: 550 }}>
        <Paper
          elevation={10}
          style={{
            padding: 20,
          }}
        >
          <Stack spacing={2}>
            <Stack spacing={1} direction="row" justifyContent="space-between">
              <Typography color={"#ffc400"} style={{ textAlign: "center" }}>
                Saldo:
              </Typography>

              <Typography color={"#ffc400"} style={{ textAlign: "center" }}>
                {new Intl.NumberFormat("es-NI", {
                  style: "currency",
                  currency: "NIO",
                }).format(saldo)}
              </Typography>
            </Stack>

            <TextField
              required
              fullWidth
              onChange={(e) => funtionSetMonto(e.target.value)}
              value={monto}
              label={"Monto Abono"}
            />

            <Button
              variant="outlined"
              startIcon={
                <FontAwesomeIcon
                  icon={faCirclePlus}
                  style={{ marginRight: 20 }}
                />
              }
              fullWidth
              onClick={() => saveChanges()}
              style={{
                borderRadius: 30,
                color: "#4caf50",
                borderColor: "#4caf50",
                padding: 12,
              }}
              size="large"
            >
              Agregar Abono
            </Button>
          </Stack>
        </Paper>
      </Container>
    </div>
  );
};

export default AddAbono;
